<template>
  <div class="text-xs-center">
    <v-dialog persistent v-model="dialog" fullscreen>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{titleAction}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-xl>
            <v-layout wrap>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-switch v-model="actived" :disabled="!Edit" :label="$t('active')" color="primary"></v-switch>
              </v-flex>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-tabs color="primary" fixed-tabs ref="tablanguage">
                  <v-tab :key="index + 100" v-for="(lang, index) in complexLanguage">{{lang.name}}</v-tab>
                  <v-tab-item :key="index + 200" v-for="(lang, index) in complexLanguage">
                    <v-container fluid grid-list-xl>
                      <v-layout wrap>
                        <v-flex d-flex lg12 md12 sm12 xs12>
                          <IgTextField
                            v-if="lang._id === '5bd9f3ee7fa5610014fed21e'"
                            :disabled="!Edit"
                            :rules="[v => rules.vacio(v,'name')]"
                            :label="$t('name')"
                            v-model="lang.rolName"
                            :status="dialog"
                          ></IgTextField>
                          <IgTextField
                            v-else
                            :disabled="!Edit"
                            :label="$t('name')"
                            v-model="lang.rolName"
                            :status="dialog"
                          ></IgTextField>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-container fluid grid-list-xl>
                      <v-layout wrap>
                        <v-flex d-flex lg12 md12 sm12 xs12>
                          <IgTextField
                            :status="dialog"
                            :disabled="!Edit"
                            :label="$t('description')"
                            v-model="lang.rolDescription"
                          ></IgTextField>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
              <v-flex d-flex lg3 md6 sm3 xs12>
                <v-autocomplete
                  :disabled="!Edit"
                  :items="typeList"
                  :rules="[v => rules.vacio(v,'type')]"
                  :label="$t('select', {field :$tc('type') })"
                  persistent-hint
                  prepend-icon="mdi-city"
                  v-model="typesSelected"
                ></v-autocomplete>
              </v-flex>
              <v-flex align-center lg9 md6 sm6 xs12>
                <v-autocomplete
                  :deletable-chips="true"
                  :disabled="!Edit"
                  :items="filteredPermissions"
                  :multiple="true"
                  :rules="[rules.length0]"
                  :small-chips="true"
                  :label="$t('select', {field :$tc('permissions') })"
                  prepend-icon="mdi-city"
                  v-model="permissionsSelected"
                  @change="searchPermission = ''"
                  :search-input.sync="searchPermission"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="reset()" color="warning" v-if="Edit">{{$t('reset')}}</v-btn>
          <v-btn
            small
            @click="sendCreate()"
            color="success"
            v-if="externalAction==='create'"
          >{{$t('save')}}</v-btn>
          <v-btn
            small
            @click="sendUpdate()"
            color="secondary"
            v-if="externalAction === 'update'"
          >{{$t('update')}}</v-btn>
          <v-btn
            small
            @click="sendDelete()"
            color="error"
            v-if="externalAction === 'delete'"
          >{{$t('delete')}}</v-btn>
          <v-btn small @click="cancel()" color="primary">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'

export default {
  name: 'formGestion',
  mixins: [rules],
  props: {
    externalState: {
      type: Boolean,
      default: false,
      required: false
    },
    externalAction: {
      type: String,
      default: 'create',
      required: false
    },
    externalRol: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    }
  },
  data() {
    return {
      searchPermission: '',
      types: [
        'entities',
        'teams',
        'participant',
        'tournaments',
        'matches',
        'users',
        'all'
      ],
      permissionsSelected: [],
      typesSelected: '',
      actived: true,
      complexLanguage: [],
      Edit: false,
      localRol: {}
    }
  },
  watch: {
    externalAction(val) {
      switch (val) {
        case 'create':
          this.localRol = {}
          this.Edit = true
          break
        case 'update':
          this.localRol = this.externalRol
          this.Edit = true
          break
        default:
          this.localRol = this.externalRol
          this.Edit = false
      }
      this.createComplexLanguage()
    },
    languages(val) {
      if (val.length > 0) {
        this.createComplexLanguage()
      }
    },
    externalRol: function() {
      this.createComplexLanguage()
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions.listSelectPermission,
      listPermissions: state => state.permissions.listPermissions,
      languages: state => state.languages.listLanguages
    }),
    dialog: {
      get() {
        return this.externalState
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
    titleAction() {
      switch (this.externalAction) {
        case 'create':
          return this.$t('newModel', { field: this.$tc('role') })
        case 'delete':
          return this.$t('deleteModel', { field: this.$tc('role') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('role') })
      }
    },
    filteredPermissions() {
      return this.permissions.filter(
        (permission, index, array) =>
          array.findIndex(p => p.text == permission.text) == index
      )
    },
    typeList() {
      return [
        { value: 'entities', text: this.$tc('entity') },
        { value: 'teams', text: this.$tc('team') },
        { value: 'participant', text: this.$t('participant') },
        { value: 'tournaments', text: this.$tc('tournament') },
        { value: 'matches', text: this.$tc('match') },
        { value: 'users', text: this.$tc('user') },
        { value: 'all', text: this.$t('admin') }
      ]
    }
  },
  mounted() {
    let me = this
    this.createComplexLanguage()
    switch (this.externalAction) {
      case 'create':
      case 'update':
        this.Edit = true
        break
      default:
        this.Edit = false
    }
  },
  methods: {
    ...mapActions({
      createNew: 'rols/setNew',
      updateRol: 'rols/setUpdate',
      deleteRol: 'rols/setEliminate'
    }),
    validateBeforeSend() {
      let result = true
      let message = []
      if (this.permissionsSelected.length < 1) {
        result = false
        message.push(
          this.$t('error.required', { field: this.$t('permissions') })
        )
      }
      if (!this.typesSelected || this.typesSelected === '') {
        result = false
        message.push(this.$t('error.required', { field: this.$t('type') }))
      }
      this.complexLanguage.forEach(item => {
        if (
          item._id === '5bd9ebae37c431001498335d' ||
          item._id === '5bd9f3ee7fa5610014fed21e'
        ) {
          if (!item.rolName) {
            result = false
            message.push(this.$t('error.nameSpanish'))
          }
        }
      })
      return {
        result,
        message
      }
    },
    createRol() {
      let name = []
      let description = []
      this.complexLanguage.forEach(item => {
        if (item.rolName) {
          name.push({
            langId: item._id,
            text: item.rolName
          })
        }
        if (item.rolDescription) {
          description.push({
            langId: item._id,
            text: item.rolDescription
          })
        }
      })
      return {
        name,
        description,
        type: this.typesSelected,
        permissions: this.permissionsSelected,
        active: this.actived
      }
    },
    sendCreate() {
      const response = this.validateBeforeSend()
      if (!response.result) {
        queueToast(response.message)
        return
      }
      this.createNew(this.createRol())
      this.dialog = false
      this.reset()
    },
    sendUpdate() {
      const response = this.validateBeforeSend()
      if (!response.result) {
        queueToast(response.message)
        return
      }
      let sendData = this.createRol()
      sendData._id = this.externalRol._id
      this.updateRol(sendData)
      this.dialog = false
      this.reset()
    },
    sendDelete() {
      this.deleteRol(this.externalRol._id)
      this.dialog = false
      this.reset()
    },
    reset() {
      this.$refs.tablanguage.internalLazyValue = 0
      this.createComplexLanguage()
      this.permissionsSelected = []
      this.typesSelected = undefined
      this.actived = true
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    createComplexLanguage() {
      let me = this
      this.complexLanguage = []
      this.languages.forEach(item => {
        item.rolName = undefined
        item.rolDescription = undefined
        me.complexLanguage.push(item)
      })
      if (
        this.externalAction === 'update' ||
        this.externalAction === 'delete'
      ) {
        this.complexLanguage.forEach((item, index) => {
          if (me.externalRol && me.externalRol.name) {
            let name = me.externalRol.name.find(
              element => element.langId === item._id
            )
            if (name) {
              me.complexLanguage[index].rolName = name.text
            }
          }
          if (me.externalRol && me.externalRol.description) {
            let description = me.externalRol.description.find(
              element => element.langId === item._id
            )
            if (description) {
              me.complexLanguage[index].rolDescription = description.text
            }
          }
        })
        this.actived = this.externalRol.active
        this.permissionsSelected = []
        if (this.externalRol && this.externalRol.permissions) {
          this.externalRol.permissions.forEach(item => {
            this.permissionsSelected.push(item._id)
          })
        }
        this.typesSelected = this.externalRol.type
      }
    }
  }
}
</script>
